import { Action } from '../../actions';
import { UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO } from '../../actions/importWizardInfo/internal/uploadImagesInImportWizardInfoGrid';
import { ImportWizardInfoState } from '../../typings/importWizardInfo';

import { uploadImagesInImportWizardInfo } from './internal/uploadImagesInImportWizardInfo';

export const getImportWizardInfoInitialState = (): ImportWizardInfoState => ({
    importImages: {
        'banner_img_1123.png': {
            image: {
                name: 'banner_img_1123.png',
                url: 'https://9361.beta2.direct.yandex.ru/images/direct/4699/ciCuET8qzf13-G_NJXmqiQ',
                height: 45,
                width: 60
            },
            banners: []
        },
        'ba.png': {
            image: {
                name: 'ba.png',
                url: 'https://9361.beta2.direct.yandex.ru/images/direct/4437/1BLndCgQA8dL6y7jOAO3IA',
                height: 45,
                width: 60
            },
            banners: []
        },
        'bann.png': {
            image: {
                name: 'bann.png',
                url: 'https://9361.beta2.direct.yandex.ru/images/direct/4699/cpKJleyrPZOr2CqXgnca8g',
                height: 45,
                width: 60
            },
            banners: []
        },
        'banner.png': {
            image: {
                name: 'banner.png',
                url: 'https://9361.beta2.direct.yandex.ru/images/direct/4437/zpHrwTreoPZPIFwkik-9qQ',
                height: 45,
                width: 60
            },
            banners: []
        },
        'banner_img_1_banner_img_1_banner_img_1_banner_img_1_banner_img_1.png': {
            image: {
                name: 'banner_img_1_banner_img_1_banner_img_1_banner_img_1_banner_img_1.png',
                url: 'https://9361.beta2.direct.yandex.ru/images/direct/4437/FGE-HRhLAfAffg_pMcENqw',
                height: 45,
                width: 60
            },
            banners: []
        }
    }
});

export function importWizardInfo(
    state: ImportWizardInfoState = getImportWizardInfoInitialState(),
    action: Action
): ImportWizardInfoState {
    switch (action.type) {
        case UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO:
            return uploadImagesInImportWizardInfo(state, action);

        default:
            return state;
    }
}
